import CityPageTemplate from "../city-template/CityPageTemplate";
import { richmondConfig } from "./data";

export default function RichmondPage() {
  return <CityPageTemplate config={richmondConfig} />;
}